<template>
  <div class="login-bg">
    <div class="login-container">
      <div class="login-left">
        <div class="slogan">
          <div class="title-main">交易<br><span>高雅的艺术</span></div>
          <div class="desc">
            海龟是一家以跨市场洞察驱动为核心的金融科技服务公司<br>
            通过国际化视野与多元化投资策略结合<br>
            为投资者提供专业、系统的课程及培训服务<br>
            助力个人和机构提升金融素养，实现财富管理的科学化、专业化和智能化
          </div>
          <div class="copyright">
            Copyright 2012--2020 JDD.com版权所有 京ICP备11041704号-31<br>
            京ICP证070359号 增值电信业务经营许可证京B2-20210006 京公网安备11010502039799号 支持IPv6
          </div>
        </div>
      </div>
      <div class="login-right">
        <div class="login-box">
          <div class="login-title">
            <img src="@/assets/logo.png" alt="logo" class="logo-img" />
            找回密码
          </div>
          <div class="reset-steps">
            <div class="step-item" :class="{ active: currentStep >= 1, completed: currentStep > 1 }">
              <div class="step-number">1</div>
              <div class="step-text">验证手机号</div>
            </div>
            <div class="step-line" :class="{ active: currentStep > 1 }"></div>
            <div class="step-item" :class="{ active: currentStep >= 2, completed: currentStep > 2 }">
              <div class="step-number">2</div>
              <div class="step-text">设置新密码</div>
            </div>
            <div class="step-line" :class="{ active: currentStep > 2 }"></div>
            <div class="step-item" :class="{ active: currentStep >= 3, completed: currentStep > 3 }">
              <div class="step-number">3</div>
              <div class="step-text">完成</div>
            </div>
          </div>
          
          <!-- 步骤1：验证手机号 -->
          <div v-if="currentStep === 1" class="step-content">
            <div class="input-wrapper">
              <img src="@/assets/password.png" class="input-icon" alt="phone">
              <input class="input" type="tel" placeholder="请输入手机号" v-model="phone" maxlength="11" />
            </div>
            <div class="input-wrapper">
              <img src="@/assets/password.png" class="input-icon" alt="code">
              <input class="input" type="text" placeholder="请输入验证码" v-model="smsCode" maxlength="6" />
              <button 
                class="send-code-btn" 
                :disabled="smsTimer > 0 || !phone || !/^1[3-9]\d{9}$/.test(phone)"
                @click="sendSmsCode"
              >
                {{ smsTimer > 0 ? `${smsTimer}s后重发` : '发送验证码' }}
              </button>
            </div>
            <button class="login-btn" :disabled="!canVerifyPhone" @click="verifyPhone">下一步</button>
          </div>

          <!-- 步骤2：设置新密码 -->
          <div v-if="currentStep === 2" class="step-content">
            <div class="input-wrapper">
              <img src="@/assets/password.png" class="input-icon" alt="password">
              <input class="input" type="password" placeholder="请输入新密码" v-model="newPassword" />
            </div>
            <div class="input-wrapper">
              <img src="@/assets/password.png" class="input-icon" alt="password">
              <input class="input" type="password" placeholder="请再次输入新密码" v-model="confirmPassword" />
            </div>
            <div class="password-tips">
              <p>密码要求：</p>
              <ul>
                <li :class="{ valid: newPassword.length >= 6 }">至少6位字符</li>
                <li :class="{ valid: /[A-Z]/.test(newPassword) }">包含大写字母</li>
                <li :class="{ valid: /[a-z]/.test(newPassword) }">包含小写字母</li>
                <li :class="{ valid: /\d/.test(newPassword) }">包含数字</li>
              </ul>
            </div>
            <button class="login-btn" :disabled="!canResetPassword" @click="resetPassword">确认修改</button>
          </div>

          <!-- 步骤3：完成 -->
          <div v-if="currentStep === 3" class="step-content">
            <div class="success-content">
              <div class="success-icon">
                <el-icon size="64" color="#67c23a">
                  <Check />
                </el-icon>
              </div>
              <h3>密码重置成功！</h3>
              <p>您的密码已经成功重置，请使用新密码登录。</p>
            </div>
            <button class="login-btn" @click="goToLogin">立即登录</button>
          </div>

          <div class="login-links">
            <router-link to="/login">返回登录</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineOptions, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import { Check } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { sendSmsApi } from '@/api/login'
import {verifyCode,resetPaasword} from '@/api/login'
const router = useRouter()
defineOptions({ name: 'ResetPasswordPage' })

const currentStep = ref(1)
const phone = ref('')
const smsCode = ref('')
const newPassword = ref('')
const confirmPassword = ref('')
const smsTimer = ref(0)
let smsInterval = null

const canVerifyPhone = computed(() => {
  return phone.value && 
         /^1[3-9]\d{9}$/.test(phone.value) && 
         smsCode.value && 
         smsCode.value.length === 6
})

const canResetPassword = computed(() => {
  console.log('newPassword:', newPassword.value)
  console.log('confirmPassword:', confirmPassword.value)
  const isValid = newPassword.value && 
         confirmPassword.value && 
         newPassword.value === confirmPassword.value &&
         newPassword.value.length >= 6 &&
         /[A-Z]/.test(newPassword.value) &&
         /[a-z]/.test(newPassword.value) &&
         /\d/.test(newPassword.value)
  console.log('isValid:', isValid)
  return isValid
})

function sendSmsCode() {
  if (!phone.value || !/^1[3-9]\d{9}$/.test(phone.value)) {
    ElMessage.warning('请输入正确的手机号')
    return
  }

  // 这里调用发送短信验证码的API
  sendSmsApi(phone.value).then(res => {
    if (res && res.code === 200) {
      ElMessage.success('验证码已发送')
      smsTimer.value = 60
      smsInterval = setInterval(() => {
        smsTimer.value--
        if (smsTimer.value <= 0) {
          clearInterval(smsInterval)
        }
      }, 1000)
    } else {
      ElMessage.error(res?.msg || '发送失败')
    }
  }).catch(err => {
    ElMessage.error('发送失败')
    console.error(err)
  })
}

function verifyPhone() {
  // 这里调用验证手机号和验证码的API
  verifyCode(phone.value, smsCode.value).then(res => {
    if (res && res.code === 200) {
      ElMessage.success('验证成功')
      currentStep.value = 2
    } else {
      ElMessage.error(res?.msg || '验证码有误，请重新输入！')
    }
  }).catch(err => {
    ElMessage.error('网络错误，请稍后重试')
    console.error(err)
  })
}

function resetPassword() {
  // 这里调用重置密码的API
  resetPaasword(phone.value, newPassword.value).then(res => {
    if (res && res.code === 200) {
      ElMessage.success('密码重置成功')
      currentStep.value = 3
    } else {
      ElMessage.error(res?.msg || '密码重置失败')
    }
  }).catch(err => {
    ElMessage.error('网络错误，请稍后重试')
    console.error(err)
  })
}

function goToLogin() {
  router.push('/login')
}

onUnmounted(() => {
  if (smsInterval) {
    clearInterval(smsInterval)
  }
})
</script>

<style scoped>
.login-bg {
  height: 100vh; 
  min-height: 100vh;
  background: url('~@/assets/regist-login.png') no-repeat center center !important;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-container {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-left {
  flex: 1.2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 420px;
  height: 100vh;
}

.slogan {
  margin-right: 60px;
  max-width: 420px;
}

.title-main {
  font-size: 2.8rem;
  font-weight: 700;
  color: #258aff;
  line-height: 1.2;
  margin-bottom: 18px;
}

.title-main span {
  color: #258aff;
}

.desc {
  color: #444;
  font-size: 1.08rem;
  margin-bottom: 32px;
  line-height: 1.7;
}

.copyright {
  color: #bbb;
  font-size: 12px;
  margin-top: 40px;
}

.login-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 420px;
  height: 100vh;
}

.login-box {
  width: 420px;
  margin-left: 40px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 32px rgba(0,64,255,0.08);
  padding: 38px 36px 28px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-img {
  width: 32px;
  height: 32px;
}

/* 步骤指示器样式 */
.reset-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  width: 100%;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e6e6e6;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s;
}

.step-item.active .step-number {
  background: #258aff;
  color: white;
}

.step-item.completed .step-number {
  background: #67c23a;
  color: white;
}

.step-text {
  font-size: 12px;
  color: #999;
  transition: color 0.3s;
}

.step-item.active .step-text {
  color: #258aff;
}

.step-item.completed .step-text {
  color: #67c23a;
}

.step-line {
  width: 40px;
  height: 2px;
  background: #e6e6e6;
  margin: 0 8px;
  transition: background 0.3s;
}

.step-line.active {
  background: #67c23a;
}

.step-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
}

.input-wrapper {
  display: flex;
  align-items: center;
  background: #fafbfc;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 0 12px;
  margin-bottom: 18px;
  height: 44px;
  transition: border 0.2s;
  position: relative;
}

.input-wrapper:focus-within {
  border: 1px solid #b3b3b3;
}

.input-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  opacity: 0.6;
}

.input-wrapper input {
  border: none;
  outline: none;
  background: transparent;
  flex: 1;
  font-size: 15px;
  color: #333;
  padding: 10px 0;
}

.input-wrapper input::placeholder {
  color: #b3b3b3;
  font-size: 15px;
}

.send-code-btn {
  background: #258aff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}

.send-code-btn:disabled {
  background: #b3d6ff;
  cursor: not-allowed;
}

.login-btn {
  width: 100%;
  background: #258aff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 0;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 6px;
  transition: background 0.2s;
}

.login-btn:disabled {
  background: #b3d6ff;
  cursor: not-allowed;
}

.login-links {
  width: 100%;
  text-align: center;
  margin-top: 12px;
  color: #888;
  font-size: 14px;
}

.login-links a {
  color: #258aff;
  text-decoration: none;
}

/* 密码提示样式 */
.password-tips {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
}

.password-tips p {
  margin: 0 0 8px 0;
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.password-tips ul {
  margin: 0;
  padding-left: 16px;
  list-style: none;
}

.password-tips li {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
  position: relative;
}

.password-tips li::before {
  content: '•';
  position: absolute;
  left: -12px;
  color: #ccc;
}

.password-tips li.valid {
  color: #67c23a;
}

.password-tips li.valid::before {
  content: '✓';
  color: #67c23a;
}

/* 成功页面样式 */
.success-content {
  text-align: center;
  padding: 20px 0;
}

.success-icon {
  margin-bottom: 16px;
}

.success-content h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.success-content p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

@media (max-width: 900px) {
  .login-left {
    display: none;
  }
  .login-right {
    flex: 1;
    justify-content: center;
    min-width: 0;
  }
  .login-box {
    margin: 0;
  }
}

@media (max-width: 500px) {
  .login-box {
    width: 98vw;
    padding: 18px 2vw 18px 2vw;
  }
  
  .reset-steps {
    margin-bottom: 20px;
  }
  
  .step-number {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
  
  .step-text {
    font-size: 11px;
  }
  
  .step-line {
    width: 30px;
  }
}
</style> 